import { createContext } from "react";

export const CreateAnnouncementModalContext = createContext();